export default "__VITE_ASSET__ClmsXC6j__"